import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The Segments tab's own URL opens Belongs to, as the embedded app's `person/segments/index` route
 * does. Belongs to hands back to the embedded app itself while the rollout flag is off.
 */
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/segments/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/people/$personId/segments/belongs',
      params,
      replace: true,
    });
  },
});
